// Meta Pixel (ID 2452467228579497) – Basis-Code liegt in public/index.html
// und feuert den initialen PageView. Diese Helfer decken SPA-Routenwechsel
// und das Lead-Event ab. Lead NUR nach erfolgreicher Backend-Registrierung.
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const fbq = () => (typeof window !== "undefined" && typeof window.fbq === "function" ? window.fbq : null);

export const trackPageView = () => {
  const f = fbq();
  if (f) f("track", "PageView");
};

export const trackLead = () => {
  const f = fbq();
  if (f) f("track", "Lead");
};

// Feuert PageView bei jedem SPA-Routenwechsel (initialer PageView kommt aus index.html)
export function RoutePageViews() {
  const location = useLocation();
  const lastUrl = useRef(null);
  const url = `${location.pathname}${location.search}${location.hash}`;

  useEffect(() => {
    if (lastUrl.current === null) {
      lastUrl.current = url;
      return;
    }
    if (lastUrl.current === url) return;
    lastUrl.current = url;
    trackPageView();
  }, [url]);

  return null;
}
